module.exports = __webpack_public_path__ + "media/你.2a6aa21f.ogg";